import React from "react";
import { ICON } from "../../../asset";

export default function Data() {
  function Agri() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-[50px] h-[50px] md:w-[30px] md:h-[30px] lg:w-[50px] lg:h-[50px] 2xl:h-[8vh] 2xl:w-[8vh]"
        // width="50px"
        // height="50px"
        viewBox="0 0 65.031 65.031"
      >
        <path
          id="agriculture"
          d="M79.5,33.53a32.482,32.482,0,1,0,9.53,22.985A32.234,32.234,0,0,0,79.5,33.53Zm5.1,34.281a32.241,32.241,0,0,0-16.888,6.853,32.683,32.683,0,0,0-3.252-5.844,30.469,30.469,0,0,1,21.429-4.975A30.506,30.506,0,0,1,84.6,67.811ZM59.234,66.074a30.266,30.266,0,0,1,8.717,18.472,29.137,29.137,0,0,1-4.891,1.528A32.521,32.521,0,0,0,26.677,61.659q-.189-1.093-.294-2.228A30.134,30.134,0,0,1,59.234,66.074Zm3.882.967a32.829,32.829,0,0,0-2.3-2.551c-.771-.771-1.584-1.5-2.411-2.186a30.331,30.331,0,0,1,28.241-2.859c-.07.743-.168,1.486-.294,2.214a32.613,32.613,0,0,0-23.237,5.382Zm-6.6-40.8A30.308,30.308,0,0,1,86.788,56.515c0,.2,0,.378-.014.575a32.574,32.574,0,0,0-29.138,3.027V47.7c1.99-.084,6.237-.631,9.04-3.448,3.756-3.756,3.462-9.965,3.448-10.217a1.108,1.108,0,0,0-1.051-1.051c-.014,0-.182-.014-.477-.014-1.472,0-6.531.252-9.741,3.462A12.377,12.377,0,0,0,55.7,42.921a9.935,9.935,0,0,0-1.542-2c-3.209-3.209-8.269-3.462-9.741-3.462-.294,0-.463.014-.477.014a1.108,1.108,0,0,0-1.051,1.051c-.014.266-.308,6.461,3.448,10.217,2.817,2.817,7.078,3.35,9.054,3.448v7.933A32.518,32.518,0,0,0,26.256,57.09c0-.2-.014-.378-.014-.575A30.308,30.308,0,0,1,56.515,26.242ZM57.65,45.457c.084-1.738.561-5.214,2.789-7.442s5.7-2.691,7.442-2.789c-.084,1.738-.561,5.214-2.789,7.442S59.4,45.359,57.65,45.457Zm-2.284,4.485c-1.738-.084-5.214-.561-7.442-2.789s-2.691-5.7-2.775-7.442c1.738.084,5.214.561,7.442,2.789C54.791,44.714,55.268,48.19,55.366,49.942ZM29.522,70.208A30.285,30.285,0,0,1,52.142,86.466,30.336,30.336,0,0,1,29.522,70.208ZM54.763,86.732A32.539,32.539,0,0,0,28.429,67.826a28.944,28.944,0,0,1-1.289-3.952A30.264,30.264,0,0,1,60.846,86.48a29.5,29.5,0,0,1-4.345.308c-.575,0-1.163-.014-1.738-.056ZM70.1,83.565a32.975,32.975,0,0,0-1.542-6.7,29.86,29.86,0,0,1,14.954-6.657A30.509,30.509,0,0,1,70.1,83.565Z"
          transform="translate(-24 -24)"
          fill="#4472C4"
        />
      </svg>
    );
  }
  function Energy() {
    return (
      <svg
        id="eco-light"
        xmlns="http://www.w3.org/2000/svg"
        // width="71.758"
        // height="71.758"
        className="w-[50px] h-[50px] md:w-[30px] md:h-[30px] lg:w-[50px] lg:h-[50px] 2xl:h-[8vh] 2xl:w-[8vh]"
        viewBox="0 0 71.758 71.758"
      >
        <path
          id="Path_1"
          data-name="Path 1"
          d="M122.461,41.749a24.667,24.667,0,1,0-35.611-.025,15.808,15.808,0,0,1,4.267,9.158,3.921,3.921,0,0,0-.965,6.3,3.925,3.925,0,0,0,2.375,6.709,10.262,10.262,0,0,0,9.978,7.866h4.326a10.262,10.262,0,0,0,9.978-7.866,3.925,3.925,0,0,0,2.375-6.709,3.921,3.921,0,0,0-.965-6.3A15.727,15.727,0,0,1,122.461,41.749ZM88.469,40.174a22.424,22.424,0,1,1,32.374.022,17.965,17.965,0,0,0-4.833,10.259H105.788V38.122h3.364a12.347,12.347,0,0,0,12.333-12.333V22.425a1.121,1.121,0,0,0-1.121-1.121h-4.485a12.35,12.35,0,0,0-11.212,7.2,12.35,12.35,0,0,0-11.212-7.2H88.97a1.121,1.121,0,0,0-1.121,1.121v3.364a12.347,12.347,0,0,0,12.333,12.333h3.364V50.455H93.323A18.052,18.052,0,0,0,88.469,40.174Zm26.011-11.76a1.121,1.121,0,0,0-1.582-.105l-7.11,6.221v-.893a10.1,10.1,0,0,1,10.091-10.091h3.364v2.242a10.1,10.1,0,0,1-10.091,10.091h-1.5L114.375,30A1.121,1.121,0,0,0,114.48,28.414ZM103.546,34.53l-7.11-6.221A1.121,1.121,0,0,0,94.959,30l6.724,5.884h-1.5A10.1,10.1,0,0,1,90.091,25.788V23.546h3.364a10.1,10.1,0,0,1,10.091,10.091Zm3.284,34.986H102.5a8.069,8.069,0,0,1-7.647-5.606h19.619A8.069,8.069,0,0,1,106.83,69.516Zm11.292-9.53a1.684,1.684,0,0,1-1.682,1.682H92.894a1.682,1.682,0,0,1,0-3.364h23.546A1.684,1.684,0,0,1,118.121,59.985ZM92.894,56.061a1.682,1.682,0,1,1,0-3.364h23.546a1.682,1.682,0,0,1,0,3.364Z"
          transform="translate(-68.788 0)"
          fill="#4472C4"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M7.849,169.121A1.121,1.121,0,0,0,6.727,168H1.121a1.121,1.121,0,0,0,0,2.242H6.727A1.121,1.121,0,0,0,7.849,169.121Z"
          transform="translate(0 -144.455)"
          fill="#4472C4"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M38.641,272.149l-4.855,2.8a1.121,1.121,0,0,0,1.121,1.942l4.855-2.8a1.121,1.121,0,1,0-1.121-1.942Z"
          transform="translate(-28.568 -233.878)"
          fill="#4472C4"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M33.785,46.09c5.2,3,4.99,2.953,5.415,2.953a1.122,1.122,0,0,0,.562-2.092l-4.855-2.8a1.121,1.121,0,0,0-1.121,1.942Z"
          transform="translate(-28.568 -37.832)"
          fill="#4472C4"
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M462.727,168h-5.606a1.121,1.121,0,0,0,0,2.242h5.606a1.121,1.121,0,0,0,0-2.242Z"
          transform="translate(-392.091 -144.455)"
          fill="#4472C4"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          d="M434.667,274.951l-4.855-2.8a1.121,1.121,0,1,0-1.121,1.942l4.855,2.8a1.121,1.121,0,1,0,1.121-1.942Z"
          transform="translate(-368.127 -233.876)"
          fill="#4472C4"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M429.258,49.044c.427,0,.224.043,5.415-2.953a1.121,1.121,0,1,0-1.121-1.942l-4.855,2.8A1.122,1.122,0,0,0,429.258,49.044Z"
          transform="translate(-368.132 -37.832)"
          fill="#4472C4"
        />
      </svg>
    );
  }
  function House() {
    return (
      <svg
        id="house"
        xmlns="http://www.w3.org/2000/svg"
        // width="71.758"
        // height="65.742"
        className="w-[50px] h-[50px] md:w-[30px] md:h-[30px] lg:w-[50px] lg:h-[50px] 2xl:h-[8vh] 2xl:w-[8vh]"
        viewBox="0 0 71.758 65.742"
      >
        <g id="Group_1" data-name="Group 1" transform="translate(0 0)">
          <path
            id="Path_8"
            data-name="Path 8"
            d="M70.994,63.012a4.435,4.435,0,0,0-6.126-1.185l-9.158,6.129L55.684,48.88l3.181,2.98a3.622,3.622,0,0,0,2.485.982h.005A3.65,3.65,0,0,0,64,51.693a3.636,3.636,0,0,0-.168-5.139L57.806,40.9a1.024,1.024,0,0,0-1.4,1.5l6.031,5.65a1.587,1.587,0,0,1-1.083,2.745h0a1.58,1.58,0,0,1-1.084-.429h0L36.317,27.93a1.024,1.024,0,0,0-1.4,0l-23.887,22.5A1.587,1.587,0,0,1,8.85,48.123L34.523,23.939a1.59,1.59,0,0,1,2.173,0l15.02,14.07a1.024,1.024,0,0,0,1.4-1.5L38.1,22.441a3.642,3.642,0,0,0-4.979.007L24.9,30.19l0-1.381a1.63,1.63,0,0,0-1.629-1.627h0l-5.879.008a1.629,1.629,0,0,0-1.627,1.632l.016,9.963-8.33,7.848a3.636,3.636,0,0,0,2.384,6.28l.111,0a3.609,3.609,0,0,0,2.49-.989l3.174-2.99.013,9.011a21.584,21.584,0,0,0-3.11-.228H10.756V57.1a3.744,3.744,0,0,0-3.739-3.739H3.739A3.743,3.743,0,0,0,0,57.1v16.05a1.024,1.024,0,1,0,2.048,0V57.1a1.693,1.693,0,0,1,1.691-1.691H7.017A1.693,1.693,0,0,1,8.707,57.1V81.358a1.693,1.693,0,0,1-1.691,1.691H3.739a1.693,1.693,0,0,1-1.691-1.691V79.566a1.024,1.024,0,1,0-2.048,0v1.792A3.744,3.744,0,0,0,3.739,85.1H7.017a3.743,3.743,0,0,0,3.739-3.739v-.139l15,5.68q.042.016.085.028a7.153,7.153,0,0,0,1.948.277,6.629,6.629,0,0,0,1.036-.081l22.043-3.178.015,0A10.791,10.791,0,0,0,56,81.651l.038-.032L70.274,68.811A4.436,4.436,0,0,0,70.994,63.012ZM22.85,29.231l0,2.886-5.033,4.741-.012-7.62Zm12.768.851L53.633,46.958l.031,22.367-2.9,1.941-3.071-.172-.081-.816A6.486,6.486,0,0,0,42.4,64.543l-.019-13.307a1.856,1.856,0,0,0-1.854-1.851h0l-9.762.014a1.854,1.854,0,0,0-1.851,1.856l.016,11.6a19.465,19.465,0,0,1-5.506-2.182q-.323-.189-.652-.366c-.085-.046-.172-.089-.259-.134-.133-.07-.267-.14-.4-.207-.107-.053-.216-.1-.324-.155s-.229-.11-.345-.162-.236-.1-.355-.156-.217-.094-.326-.139-.245-.1-.367-.147-.218-.085-.327-.126-.244-.089-.366-.132-.23-.08-.345-.119-.235-.077-.353-.115-.252-.078-.378-.115c-.109-.032-.217-.064-.326-.094-.143-.04-.286-.077-.429-.114-.067-.017-.134-.037-.2-.053l-.016-11.335Zm4.735,34.2L31.786,63.3l-.807-.093-.017-11.76,9.373-.013Zm28.556,3-14.227,12.8a8.741,8.741,0,0,1-4.115,1.839L28.533,85.094l-.014,0-.015,0a4.883,4.883,0,0,1-2.066-.132L10.756,79.028V59.766h1.753a19.559,19.559,0,0,1,4.417.507l.161.038c.177.043.354.087.53.134l.046.013q.265.072.527.152l.094.029q.28.086.557.181l.057.02q.577.2,1.141.434l.061.026q.281.118.559.245l.015.007q.268.123.533.255l.062.031q.259.129.513.267l.1.052c.172.093.342.189.511.288a21.516,21.516,0,0,0,7.886,2.745l.026,0,11.476,1.321q.1.014.189.031a4.442,4.442,0,0,1,3.469,3.191,4.5,4.5,0,0,1,.138.745l.046.458L24.112,69.055a1.024,1.024,0,0,0-.179,2.041l22.739,1.992h.016l.016,0,4.288.241.057,0c.02,0,.04,0,.061,0s.046,0,.068-.005.06-.011.09-.017.043-.008.064-.014a.994.994,0,0,0,.1-.035c.017-.007.035-.012.052-.02a1.012,1.012,0,0,0,.139-.077l3.64-2.436h0l10.75-7.194a2.377,2.377,0,0,1,2.9,3.755Z"
            transform="translate(0 -21.461)"
            fill="#4472C4"
          />
        </g>
      </svg>
    );
  }
  function Water() {
    return (
      <svg
        id="save-water_1_"
        data-name="save-water (1)"
        xmlns="http://www.w3.org/2000/svg"
        // width="71.758"
        // height="71.746"
        className="w-[50px] h-[50px] md:w-[30px] md:h-[30px] lg:w-[50px] lg:h-[50px] 2xl:h-[8vh] 2xl:w-[8vh]"
        viewBox="0 0 71.758 71.746"
      >
        <g id="Group_3" data-name="Group 3" transform="translate(9.766 57.482)">
          <g id="Group_2" data-name="Group 2">
            <path
              id="Path_9"
              data-name="Path 9"
              d="M72.44,411.218a1.4,1.4,0,1,0-.991,1.717A1.4,1.4,0,0,0,72.44,411.218Z"
              transform="translate(-69.685 -410.18)"
              fill="#4472C4"
            />
          </g>
        </g>
        <g id="Group_5" data-name="Group 5" transform="translate(0 38.476)">
          <g id="Group_4" data-name="Group 4">
            <path
              id="Path_10"
              data-name="Path 10"
              d="M71.421,293.539a5.62,5.62,0,0,0-7.1-3.4L52.707,293.1a5.6,5.6,0,0,0-2.656-6.135L30.219,275.512a6.961,6.961,0,0,0-5.317-.7L13.372,277.9a4.2,4.2,0,0,0-4.212-1.245l-8.121,2.176a1.4,1.4,0,0,0-.991,1.716l5.8,21.656a1.4,1.4,0,0,0,1.716.991l8.12-2.176a4.23,4.23,0,0,0,3.037-3.267l1.97-.491a4.189,4.189,0,0,1,3.12.441l14.721,8.443a12.546,12.546,0,0,0,9.4,1.3c.034-.009.068-.019.1-.03l19.976-6.7.029-.01A5.612,5.612,0,0,0,71.421,293.539Zm-56.458,4.774L8.2,300.127,3.118,281.178l2.707-.725,2.539,9.474a1.4,1.4,0,0,0,2.707-.726l-2.539-9.474,1.353-.363a1.4,1.4,0,0,1,1.717.99L15.954,296.6A1.406,1.406,0,0,1,14.963,298.313Zm52.148-.241L47.2,304.747a9.76,9.76,0,0,1-7.269-1.028l-14.721-8.444a6.977,6.977,0,0,0-5.195-.732l-1.607.4L14.54,280.491l11.088-2.971a4.176,4.176,0,0,1,3.19.419L48.65,289.391a2.8,2.8,0,0,1-2.8,4.853l-12.135-7.006a1.4,1.4,0,0,0-1.4,2.427l12.134,7.006a5.572,5.572,0,0,0,5.607,0c15.943-4.062,15.024-3.82,15.144-3.863a2.8,2.8,0,0,1,1.915,5.268Z"
              transform="translate(0 -274.571)"
              fill="#4472C4"
            />
          </g>
        </g>
        <g id="Group_7" data-name="Group 7" transform="translate(40.927 0)">
          <g id="Group_6" data-name="Group 6">
            <path
              id="Path_11"
              data-name="Path 11"
              d="M320.264,18.963,308.614.688a1.4,1.4,0,0,0-2.363,0L294.6,18.963c-6.837,10.256.753,24.375,12.832,24.375C319.482,43.338,327.12,29.247,320.264,18.963ZM307.432,40.535c-9.753,0-16.143-11.571-10.493-20.028l.016-.025L307.432,4.048l10.477,16.434.016.025C323.556,28.934,317.244,40.535,307.432,40.535Z"
              transform="translate(-292.019 -0.04)"
              fill="#4472C4"
            />
          </g>
        </g>
        <g
          id="Group_9"
          data-name="Group 9"
          transform="translate(54.939 21.402)"
        >
          <g id="Group_8" data-name="Group 8">
            <path
              id="Path_12"
              data-name="Path 12"
              d="M401.565,153.37a1.4,1.4,0,1,0-2.331,1.556,6.967,6.967,0,0,1,1.172,3.882c0,3.956-3.274,7.427-7.006,7.427a1.4,1.4,0,0,0,0,2.8,10.16,10.16,0,0,0,9.809-10.229A9.762,9.762,0,0,0,401.565,153.37Z"
              transform="translate(-391.999 -152.746)"
              fill="#4472C4"
            />
          </g>
        </g>
      </svg>
    );
  }
  const array = [
    {
      id: 1,
      img: <Agri />,
      // img: IMG.in1,
      name: "Agriculture",
    },
    {
      id: 2,
      img: <Energy />,
      name: "Energy",
    },
    {
      id: 3,
      img: <House />,
      name: "Housing",
    },
    {
      id: 4,
      img: <Water />,
      name: "Water",
    },
  ];

  return (
    <div className="w-full h-auto md:h-[25vh] flex justify-center  lg:py-2 ">
    {/* <div className="w-full h-auto flex justify-center md:pt-4 lg:py-2"> */}
      <div className="h-full w-full grid grid-cols-1 md:grid-cols-10 px-10 ">
        <div className="col-span-5 w-full h-auto grid sm:grid-cols-10 grid-cols-1 relative">
          <div className="flex w-auto h-auto items-center justify-center col-span-4 md:col-span-3 py-5 sm:py-0">
            <img
              src={ICON.chain}
              alt="user"
              className="h-[150px] md:h-[80px] lg:h-[105px] xl:h-[150px] object-contain"
            />
          </div>

          <div className="w-full h-full flex justify-center items-center sm:items-start flex-col col-span-6 md:col-span-7 px-3">
            <p className="text-jusify text-[15px] sm:text-[30px] md:text-[11px] lg:text-[15px] xl:text-[20px] 2xl:text-[3vh] text-center md:text-start font-light">
              We are an investment network based on long-trusted ties.
            </p>
          </div>
          <div className="hidden md:block absolute inset-y-0 right-0  h-[80%] mt-4 border-dark bg-grayl w-[1px] opacity-25"></div>
        </div>
        <div className="block md:hidden my-10 w-full border-dark bg-grayl h-[1px] opacity-25"></div>

        <div className="col-span-5 w-full flex items-center mt-0 sm:mt-5 md:mt-0 px-5 sm:px-15">
          <div className="text-center md:text-start w-full">
            <div className="flex justify-start items-center ">
              <div className="w-full flex items-center text-center">
                <p className=" text-[15px] sm:text-[30px] md:text-[11px] lg:text-[15px] xl:text-[20px]  2xl:text-[3vh] text-[#4472C4] font-light w-full text-center">
                  We invest in Essential
                  <span className="font-bold"> Texas</span> industries
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 w-full mt-2 py-10 sm:py-0">
              {array.map((data) => (
                <div
                  className="flex flex-col items-center justify-center pb-4 md:mb-0"
                  key={data.id}
                >
                  {data.img}
                  <div className="grid items-center justify-center">
                    <p className="text-dark text-base text-[8px] md:text-[8px] xl:text-sm  2xl:text-[1.8vh] text-center">
                      {data.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
